import { TRUST_LOGO_TILES, TRUST_LOGO_TILE_SIZE } from './content';
import * as styles from './TrustBar.css';

const LogoList = ({ hidden = false }: { hidden?: boolean }) => (
  <ul className={styles.list} aria-hidden={hidden || undefined}>
    {TRUST_LOGO_TILES.map((tile) => (
      <li key={tile.name} className={styles.tile}>
        <img
          className={styles.logo}
          src={tile.src}
          alt={hidden ? '' : tile.name}
          width={TRUST_LOGO_TILE_SIZE.width}
          height={TRUST_LOGO_TILE_SIZE.height}
          loading="lazy"
        />
      </li>
    ))}
  </ul>
);

export const TrustBar = () => (
  <section className={styles.trustBar}>
    <h2 className={styles.heading}>
      4 million people in
      <br />
      500K companies use Blinq
    </h2>
    <div className={styles.marquee}>
      <div className={styles.track}>
        <LogoList />
        <LogoList hidden />
      </div>
    </div>
  </section>
);
